import React from 'react'
import '../../css/main.css'

function Footer() {
    return(
        <>
        <div className="footer bg-dark">
        <p className="footer-words">
            *Items on this site are not actually for purchase on this site. This site is strictly for educational purposes to practice
            API calls while using React and Redux*
        </p>
        </div>
        </>
    )
}

export default Footer
